import React from 'react';
import { IconTooltip, Text } from '@forecast-it/design-system';
export function DateRestrictionInfoIcon({ message }) {
    return message ? (React.createElement(IconTooltip, { icon: 'info', color: 'disabled', iconSize: 's' },
        React.createElement(Text, { size: '2', color: 'medium' }, message))) : null;
}
